module.exports = __webpack_public_path__ + "img/icon (3).44150dc3.png";